/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for splitColumnTreatment. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="splitColumnTreatment"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}string"&gt; &lt;enumeration value="show"/&gt; &lt;enumeration value="hide"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class SplitColumnTreatment extends Enum{

	enumValue = null;

	static  SHOW = SplitColumnTreatment.newLiteral("show");

	static  HIDE = SplitColumnTreatment.newLiteral("hide");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < SplitColumnTreatment.values().length); ++i) {
			if (SplitColumnTreatment.values()[i].enumValue == v) {
				return SplitColumnTreatment.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("SplitColumnTreatment" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/SplitColumnTreatment.js